import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledStudentTaskDetailContent = styled.div`
  display: flex;
  justify-content: center;
  .width-wrapper {
    max-width: 800px;
    width: 100%;
    h1 {
      font-size: 28px;
    }

    .instructions {
      background: ${Colors.secondBackground};
      border: 1px solid ${Colors.border};
      padding: 20px;
      font-size: 120%;
    }
    .do-message {
      font-size: 120%;
    }

    .due-date {
      text-align: right;
    }
  }
`;
